const UserHeader = () => {
    return (
      <header className="bg-yellow text-black p-4 shadow-md flex flex-row">
        <h1 className="text-xl font-bold">The News</h1>
      </header>
    );
  };
  
  export default UserHeader;
  
  